<template>
	<div>
		<div class="page-navbar navbar-white">
			<div class="nav-center-wrapper">
				<img class="navbar-logo" :src="$logoSrc" alt="getREEF Logo" />
			</div>
			<div class="navbar-content desktop-center">
				<div class="user-menu-left">
					<button
						class="button button-transparent user-menu-button"
						@click="openUserMenuModal"
					>
						<i class="sk-icon-bars-regular"></i>
					</button>
					<UserPicture @click.native="openUserMenuModal" :size="25" />
				</div>
				<button
					v-if="showCartButton && cartItemCount > 0"
					@click="cartButtonClicked"
					class="
						button button-auto button-primary
						shopping-cart-button
					"
				>
					<i class="sk-icon-shopping-cart-solid"></i>
					{{ cartItemCount }}
				</button>
				<button
					v-else-if="showCartButton"
					@click="cartButtonClicked"
					class="
						button button-auto button-transparent
						shopping-cart-button
					"
				>
					<i class="sk-icon-shopping-cart-solid"></i>
				</button>
			</div>
		</div>
		<div class="navbar-spacer"></div>
		<UserMenuModal ref="userMenuModal" />
	</div>
</template>

<style scoped>
.navbar-content {
	justify-content: space-between;
}

.shopping-cart-button {
	font-size: 12px;
	display: flex;
}

.shopping-cart-button i {
	font-size: 14px;
}

.shopping-cart-button.button-transparent i {
	color: var(--gR-base-80);
}

.shopping-cart-button.button-primary {
	padding: 6px 25px;
}

.shopping-cart-button.button-primary i {
	margin-right: 10px;
}

@media (max-width: 500px) {
	.shopping-cart-button.button-primary {
		padding: 6px 20px;
	}
}
</style>

<script>
import navbarMixin from "@/mixins/navbar-mixin"
import UserMenuModal from "@/components/modals/UserMenuModal.vue"
import UserPicture from "@/components/common/UserPicture.vue"

export default {
	name: "ResidentialHomeNavbar",
	mixins: [navbarMixin],
	components: {
		UserMenuModal,
		UserPicture
	},
	computed: {
		slug() {
			return this.$route.params.slug
		},
		cartItemCount() {
			return this.$store.getters.itemsInCartCount
		},
		showCartButton() {
			return (
				this.$store.state.business &&
				this.$store.state.business.is_active != 0
			)
		}
	},
	methods: {
		cartButtonClicked() {
			this.$store.dispatch("sendMixpanelEvent", {
				msg: "Home Cart Clicked",
				data: {
					item_count: this.cartItemCount,
					menu_type: this.$store.getters.cartMenuType
				}
			})
			this.$emit("openCart")
		}
	}
}
</script>